import axios from "../../../axios";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import urls from "../../../Utils/urls";
import FormBox from "../../../components/FormBox/FormBox";
import { commonToast } from "../../../Utils";
import { useAbortController } from "../../../hooks/useAbortController";
import { createUserSchema } from "../../../Utils/formOptions";

const AdminCreateUser = ({ update = false }) => {
  const { signal } = useAbortController();
  const { type, user_id } = useParams();
  const [moduleOptions, setModuleOptions] = useState([]);
  const [message, setMessage] = useState("Your Password is");
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [assignRoleOptions, setAssignRoleOptions] = useState([]);
  const selectedRoleValue = useSelector(
    (state) => state.account.selectedRole.value
  );
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));

  const [reportOptions, setReportOptions] = useState([]);
  const [errorMess, setErrorMess] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const intialState = user_id
    ? {
        firstName: "",
        lastName: "",
        mobile: "",
        departmentName: "",
        email: "",
        moduleAccess: "",
        reports: "",
        account: [
          {
            label: "",
            value: "",
          },
        ],
        status: "",
      }
    : {
        firstName: "",
        lastName: "",
        mobile: "",
        departmentName: "",
        email: "",
        moduleAccess: "",
        reports: "",
      };
  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: intialState,
    ...createUserSchema,
  });

  const navigate = useNavigate();
  const backToOrigin = async () => {
    setShowTimeoutModal(false);
    setErrorMess(false);
    navigate("/admin-menu");
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          urls.admin.getUserByID(user_id),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
          },
          { signal }
        );
        if (res) {
          const updatedObj = transformApiResponse(res.data);
          Object.keys(updatedObj)?.forEach((key) => {
            setValue(key, updatedObj[key]);
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    user_id && fetchData();
  }, [setValue, user_id]);

  useEffect(() => {
    const fetchData2 = async () => {
      try {
        const res = await axios.get(
          urls.admin.getRoleOptions(userDetails.user_id, selectedRoleValue),
          // `https://api-p.loanlinq.com/ords/loanlinq/v1/llq_user_role_mod_rep/${userDetails.user_id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
          },
          { signal }
        );
        if (res) {
          const data = res.data.items;
          const options = data.map((role) => ({
            label: role.role_name,
            value: role.role_id,
          }));
          setAssignRoleOptions(options);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData2();
  }, []);
  const fetchRoleDetails = async (roleId) => {
    setDisableBtn(true);
    try {
      const res = await axios.get(
        urls.admin.getRoleDetails(roleId),
        // `https://api-p.loanlinq.com/ords/loanlinq/v1/role_report_mod_dtl/${roleId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        },
        { signal }
      );
      if (res) {
        const roleDetails = res.data.items[0];
        setValue("moduleAccess", roleDetails.module_id);
        setValue("reports", roleDetails.report_id);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDisableBtn(false);
    }
  };

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "assignedRole" && value.assignedRole) {
        fetchRoleDetails(value.assignedRole);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = async (data) => {
    const id = toast.loading(
      `${type === "Create" ? "Creating" : "Updating"} a user`
    );
    const headers = {
      headers: {
        user_id: localStorage.getItem("apex_userid"),
      },
    };

    try {
      const removeLeadingColon = (value) => {
        if (typeof value === "string" && value.startsWith(":")) {
          return value.slice(1);
        }
        return value;
      };
      const res = await axios.post(
        urls.dashboard.getUserManagement(),
        {
          USER_ID: type === "Create" ? "" : `${user_id}`,
          FIRST_NAME: data?.firstName,
          LAST_NAME: data?.lastName,
          USERNAME: data?.email,
          EMAIL: data?.email,
          MOBILE: data?.mobile,
          IS_ACTIVE: data?.status,
          ACTION: type === "Create" ? "I" : "U",
          ROLE: `${data.assignedRole}`,
          CREATED_BY_USER_ID:
            type === "Create" ? "" : localStorage.getItem("apex_userid"),
          MODULE_ID:
            selectedRoleValue === "B"
              ? removeLeadingColon("42:6:7:140:142")
              : removeLeadingColon(data?.moduleAccess),
          REPORT_ID: removeLeadingColon(data?.reports),
          ACCOUNTS: data?.account?.map((data) => data?.value || ""),
        },
        headers
      );

      if (
        res.status === 200 &&
        res.data?.includes("Email Address already registed with us!")
      ) {
        setErrorMess(true);
        setShowTimeoutModal(true);
        toast.update(id, {
          render: `Email Address already registed with us!`,
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      } else if (
        res.status === 200 &&
        !res.data?.includes("Email Address already registed with us!")
      ) {
        toast.update(id, {
          render: `User ${type}d Successfully`,
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        if (!user_id) {
          const str = res.data;
          const password =
            JSON.parse(
              str?.substring(str?.indexOf("{"), str?.lastIndexOf("}") + 1)
            )?.password || "";
          setShowTimeoutModal(true);
          // setMessage(`Created User Password is ${password}`);

          setMessage(` Account Created Successfully
            An email has been sent to the registered mailbox.`);
        }
      }
    } catch (error) {
      console.error("Error submitting data", error);
      toast.update(id, {
        render: `Error ${type}ing user: ${error.message}`,
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      // Dismiss the loading toast after a delay
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }
  };

  useEffect(() => {
    const detailRole = JSON.parse(
      JSON.parse(localStorage?.getItem("user-details"))?.details?.roles
    )?.filter((data) => data?.role_type === selectedRoleValue)[0];

    const updatedRoute =
      detailRole?.nav_menu
        ?.sort((a, b) => a?.menu_order - b?.menu_order)
        .map((data) => ({
          label: data.menu_name,
          value: data.menu_id,
        })) || [];
    const reportNameList =
      detailRole?.report_list?.map((data) => ({
        label: data.rep_name,
        value: data.rep_id,
      })) || [];
    setReportOptions(reportNameList);
    setModuleOptions(updatedRoute);
  }, []);

  return (
    <section
      className="rounded"
      style={{ background: "#eeeeee", minHeight: "100vh", padding: "10px" }}
    >
      <article className="container-fluid">
        <div className="p-3 pb-0  mt-1">
          <h6>
            <span
              className="linkClick"
              role="button"
              onClick={() => navigate("/admin-menu")}
            >
              Admin Menu
            </span>{" "}
            / {type} User
          </h6>
        </div>
        <form className="bg-white" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-5">
            <div className="row">
              <div className="mb-4">
                <h4>User Information</h4>
              </div>
              <FormBox
                options={[
                  {
                    title: "First Name",
                    field: "firstName",
                    type: "text",
                    className: "col-6",
                    blur: true,
                  },
                  {
                    title: "Last Name",
                    field: "lastName",
                    type: "text",
                    className: "col-6",
                    blur: true,
                  },
                  {
                    title: "Phone Number",
                    field: "mobile",
                    type: "phoneNumber",
                    className: "col-6",
                  },
                  // {
                  //   title: "Department Name",
                  //   field: "departmentName",
                  //   type: "text",
                  //   className: "col-6",
                  // },
                ]}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />

              <h4 className="mt-5 mb-4">User Name</h4>
              <FormBox
                options={[
                  {
                    title: "Email",
                    field: "email",
                    type: "text",
                    className: "col-6",
                    blur: true,
                  },
                  {
                    field: "status",
                    title: "Activated",
                    type: "select",
                    className: "col-6",
                    options: [
                      {
                        label: "Active",
                        value: "Y",
                      },
                      {
                        label: "Inactive",
                        value: "N",
                      },
                    ],
                    blur: true,
                  },
                  {
                    title: "Assign Account(s)",
                    field: "account",
                    type: "lenderSelect",
                    isMulti: true,
                  },
                  {
                    field: "assignedRole",
                    title: "Assign Role",
                    type: "select",
                    className: "col-6",
                    options: assignRoleOptions,
                    blur: true,
                  },
                ]}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
              {selectedRoleValue !== "B" && (
                <>
                  <div className="my-5 py-3">
                    <h4>Permissions</h4>
                  </div>
                  <FormBox
                    options={[
                      {
                        title: "Module Access",
                        field: "moduleAccess",
                        type: "switchList",
                        options: moduleOptions,
                        className: "col-4",
                        disabled: true,
                      },
                      {
                        title: "Reports",
                        field: "reports",
                        type: "switchList",
                        options: reportOptions,
                        className: "col-6",
                        disabled: true,
                      },
                    ]}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    errors={errors}
                  />
                </>
              )}
            </div>
            <div className="d-flex justify-content-end mt-5">
              <button
                type="button"
                className="btn btn-secondary me-3"
                onClick={() => navigate("/admin-menu")}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary text-white"
                disabled={disableBtn}
              >
                {type} User
              </button>
            </div>
          </div>
        </form>
      </article>
      <ModalOutput
        content={message}
        backToOrigin={backToOrigin}
        showTimeoutModal={showTimeoutModal}
        error={errorMess}
      />
    </section>
  );
};
export default AdminCreateUser;
function transformApiResponse(apiResponse) {
  let transformedObj = {
    firstName: "",
    lastName: "",
    mobile: "",
    departmentName: "",
    email: "",
    // moduleAccess: "",
    // reports: "",
    account: [],
    assignedRole: "",
    status: "Y", // Assuming default status is "Y"
  };

  if (apiResponse.items && apiResponse.items?.length > 0) {
    const user = apiResponse.items[0];

    // Parse details JSON
    let details = {};
    try {
      details = JSON.parse(user.details);
    } catch (error) {
      console.error("Error parsing details JSON:", error);
    }

    // Assign values
    transformedObj.firstName = details.first_name || "";
    transformedObj.lastName = details.last_name || "";
    transformedObj.mobile = details.mobile || "";
    transformedObj.email = user.email || "";
    transformedObj.assignedRole = details.role[0].role_id || "";

    // Concatenate role IDs for moduleAccess
    // let navIds = [];
    // details.role[0]?.nav_menu?.forEach((nav) => {
    //   navIds.push(nav.menu_id);
    // });
    // transformedObj.moduleAccess = navIds.join(":");

    // Concatenate report IDs for reports
    // let reportIds = [];
    // details.role[0]?.report_list?.forEach((report) => {
    //   reportIds.push(report.rep_id);
    // });
    // transformedObj.reports = reportIds.join(":");

    // Process account details
    details.account?.forEach((acc) => {
      const accountLabel = `${acc.fullname} : ${acc.account}`;
      if (!transformedObj.account.find((a) => a.label === accountLabel)) {
        transformedObj.account.push({
          label: accountLabel,
          value: acc.recid,
        });
      }
    });
  }

  return transformedObj;
}

const ModalOutput = ({ content, showTimeoutModal, backToOrigin, error }) => {
  return (
    <Modal show={showTimeoutModal} onHide={() => backToOrigin()}>
      <Modal.Header closeButton>
        <Modal.Title>{error ? "" : "Created User"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <p className="text-center">
            <b className="text-error">
              Email Address already registed with us!
            </b>
          </p>
        ) : (
          <>
            <b className="text-success">Account Created Successfully!</b>
            <p>An email has been sent to the registered mailbox.</p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={backToOrigin}>
          Back to Admin Menu
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
